import { render, staticRenderFns } from "./LockUnlockAccountCards.vue?vue&type=template&id=56e515e8&scoped=true&"
import script from "./LockUnlockAccountCards.vue?vue&type=script&lang=js&"
export * from "./LockUnlockAccountCards.vue?vue&type=script&lang=js&"
import style0 from "./LockUnlockAccountCards.vue?vue&type=style&index=0&id=56e515e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e515e8",
  null
  
)

export default component.exports